import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown, Sparkles } from "lucide-react";
import { WHATSAPP_URL } from "../data/services";

const MaskedLine = ({ children, delay }) => (
    <span className="block overflow-hidden pb-1">
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const Hero = () => {
    const { scrollY } = useScroll();
    const ySpark = useTransform(scrollY, [0, 600], [0, -140]);
    const yLogo = useTransform(scrollY, [0, 600], [0, 120]);
    const rotate = useTransform(scrollY, [0, 600], [0, 30]);

    return (
        <section id="inicio" className="relative min-h-screen flex flex-col justify-center overflow-hidden pt-20">
            <motion.div
                style={{ y: yLogo }}
                className="absolute -right-24 top-1/4 w-[420px] h-[420px] opacity-[0.06] pointer-events-none select-none hidden lg:block"
                aria-hidden="true"
            >
                <img src="/media/logo.jpeg" alt="" className="w-full h-full object-cover rounded-full" />
            </motion.div>
            <motion.div
                style={{ y: ySpark, rotate }}
                className="absolute right-8 md:right-24 top-32 text-coral pointer-events-none"
                aria-hidden="true"
            >
                <Sparkles size={56} strokeWidth={1.2} />
            </motion.div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 w-full relative z-10">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.9, duration: 0.8 }}
                    className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-slateblue mb-8"
                >
                    Agencia digital — Alicante, España
                </motion.p>

                <h1 className="font-display font-black tracking-tighter leading-[0.95] text-[13vw] md:text-[9vw] lg:text-[7.5vw]">
                    <MaskedLine delay={0.15}>Grabamos.</MaskedLine>
                    <MaskedLine delay={0.3}>
                        <span className="italic font-medium text-coral">Creamos.</span>
                    </MaskedLine>
                    <MaskedLine delay={0.45}>Hacemos crecer.</MaskedLine>
                </h1>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.1, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-12 max-w-xl"
                >
                    <p className="text-base md:text-lg text-slateblue leading-relaxed">
                        Producción audiovisual, fotografía, gestión de redes sociales y sitios
                        web para marcas con ambición. En Alicante y para toda España.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-4">
                        <a
                            data-testid="hero-whatsapp-btn"
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group bg-coral text-navy px-8 py-4 font-mono text-sm uppercase tracking-[0.15em] font-semibold hover:bg-navy hover:text-cream transition-colors duration-300"
                        >
                            Hablemos por WhatsApp
                        </a>
                        <a
                            data-testid="hero-packs-btn"
                            href="#servicios"
                            className="border border-navy px-8 py-4 font-mono text-sm uppercase tracking-[0.15em] hover:bg-navy hover:text-cream transition-colors duration-300"
                        >
                            Ver packs y precios
                        </a>
                    </div>
                </motion.div>
            </div>

            <motion.a
                data-testid="hero-scroll-down"
                href="#video"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.6 }}
                className="absolute bottom-10 left-6 md:left-12 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-slateblue"
            >
                <motion.span animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.8 }}>
                    <ArrowDown size={16} />
                </motion.span>
                Desliza
            </motion.a>
        </section>
    );
};
